import(/* webpackChunkName: "gkCheckoutInfoModal" */ '../../Styles/GKCheckoutInfoModal/gkCheckoutInfoModal.scss');


class GKCheckoutInfoModal {
    constructor(form) {
        this.form = form;
        this.modalSelector = '.shop-gk-checkout-info-modal';
        this.modalOverlaySelector = '.shop-gk-checkout-info-modal-overlay';
        this.template = document.querySelector(`.shop-gk-checkout-info template`);
        this.pathname = null;
    }

    setup() {
        const that = this;

        that.SetEvents();
    }

    SetEvents() {
        const that = this;

        $(document).on('click', (e) => {
            if (e.target == undefined ||
                e.target.pathname == undefined) {
                return;
            }

            const $target = $(e.target);

            if ($target.data('target') == 'blank') {
                return;
            }

            if (e.target.pathname.indexOf('/lotterie/geschaeftskunden') == 0) {
                e.preventDefault();
                this.getCheckoutCart((response) => {
                    if (response != undefined
                        && response.data != undefined
                        && response.data.cartItems.length > 0) {
                        that.pathname = e.target.pathname + e.target.search;
                        that.open();
                    } else {
                        window.location = e.target.pathname + e.target.search;
                    }
                });
            }
        });
    }

    open() {
        this.copyTemplateToBody();
        this.hideBodyOverflow(true);
        this.SetModalEvents();
    }

    SetModalEvents() {
        const that = this;

        $('.shop-gk-checkout-info-modal-cancel').on('click', () => {
            that.close();
        });

        $('.shop-gk-checkout-info-modal-next').on('click', () => {
            window.location = that.pathname;
        });
    }

    close() {
        const $body = $('body');
        const $modal = $body.children(this.modalSelector);
        const $modalOverlay = $body.children(this.modalOverlaySelector);

        $modalOverlay.remove();
        $modal.remove();
        this.hideBodyOverflow(false);
    }

    copyTemplateToBody() {
        const $body = $('body');
        $body.append(this.template.content.cloneNode(true));
    }

    hideBodyOverflow(status) {
        const $body = $('body');

        if (status) {
            $body.css('overflow', 'hidden');
        } else {
            $body.css('overflow', 'auto');
        }
    }

    getCheckoutCart(callbcack) {
        const requestOptions = {
            method: "GET",
        };

        fetch("/api/lotterie/checkout/order/get", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                callbcack(result)
            })
            .catch((error) => {
                console.error(error);
            });
    }
}


const rendering = document.querySelector(".shop-gk-checkout-info");
if (rendering) {
    const modal = new GKCheckoutInfoModal(rendering);
    modal.setup();
}
